const GoogleIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_25_424)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1 10.2273C20.1 9.51825 20.0364 8.83643 19.9182 8.18188H10.5V12.0501H15.8818C15.65 13.3001 14.9455 14.3592 13.8864 15.0682V17.5773H17.1182C19.0091 15.8364 20.1 13.2728 20.1 10.2273Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 20C13.1998 20 15.4635 19.1046 17.118 17.5773L13.8862 15.0682C12.9907 15.6682 11.8453 16.0228 10.4998 16.0228C7.89529 16.0228 5.69075 14.2637 4.90439 11.9H1.56348V14.4909C3.20893 17.7591 6.59075 20 10.4998 20Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.90455 11.9001C4.70455 11.3001 4.59091 10.6592 4.59091 10.0001C4.59091 9.34097 4.70455 8.70006 4.90455 8.10006V5.50916H1.56364C0.886364 6.85916 0.5 8.38643 0.5 10.0001C0.5 11.6137 0.886364 13.141 1.56364 14.491L4.90455 11.9001Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 3.97727C11.968 3.97727 13.2862 4.48182 14.3226 5.47273L17.1907 2.60455C15.4589 0.990909 13.1953 0 10.4998 0C6.59075 0 3.20893 2.24091 1.56348 5.50909L4.90439 8.1C5.69075 5.73636 7.89529 3.97727 10.4998 3.97727Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_25_424">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export { GoogleIcon };
